import { createRouter, createWebHashHistory } from "vue-router";
import ExamList from "@/views/exam/List.vue";
import ExamBlock from "@/views/exam/ExamBlock.vue";
import examVocabulary from "@/views/exam/exam-Vocabulary.vue";
import examGrammar from "@/views/exam/exam-Grammar.vue";
import examReading from "@/views/exam/exam-Reading.vue";
import examWriting from "@/views/exam/exam-Writing.vue";
import examListen from "@/views/exam/exam-Listen.vue";
import examOral from "@/views/exam/exam-Oral.vue";
import examMock from "@/views/exam/exam-Mock.vue";
import PaperBlock from "@/views/preview/PaperBlock.vue";
import Reports from "@/views/report/Reports.vue";
import ReportBlock from "@/views/report/ReportBlock.vue";
import Feedback from "@/views/user/Feedback.vue";
// import BlockPage from "@/views/BlockPage.vue";
import OralTest from "@/views/testSet/OralTest.vue";
import UserInfo from "@/views/user/UserInfo.vue";

const routes = [
  {
    path: "/",
    redirect: "/examlist",
  },
  //列表
  {
    path: "/examlist",
    meta: {
      type: "examlist",
    },
    component: ExamList,
  },
  //考试内容
  {
    path: "/exam",
    meta: {
      type: "exam",
    },
    component: ExamBlock,
    children: [
      {
        path: "vspt",
        meta: {
          type: "exam",
          skill: "S0",
        },
        component: examVocabulary,
      },
      {
        path: "grammar",
        meta: {
          type: "exam",
        },
        component: examGrammar,
      },
      {
        path: "reading",
        meta: {
          type: "exam",
        },
        component: examReading,
      },
      {
        path: "writing",
        meta: {
          type: "exam",
        },
        component: examWriting,
      },
      {
        path: "listen",
        meta: {
          type: "exam",
        },
        component: examListen,
      },
      {
        path: "mock",
        meta: {
          type: "exam",
        },
        component: examMock,
      },
      {
        path: "oral",
        meta: {
          type: "exam",
        },
        component: examOral,
      },
      {
        path: "oralgc",
        meta: {
          type: "exam",
        },
        component: () => import("@/views/exam/exam-Oral-gc.vue"),
      },
      {
        path: "oralq",
        meta: {
          type: "exam",
        },
        component: () => import("@/views/exam/exam-Oral-q.vue"),
      },
    ],
  },
  //预览
  {
    path: "/preview",
    meta: {
      type: "preview",
    },
    component: PaperBlock,
  },
  {
    path: "/reports",
    meta: {
      type: "reports",
    },
    component: Reports,
  },
  {
    path: "/report",
    meta: {
      type: "exam",
    },
    component: ReportBlock,
  },
  {
    path: "/feedback",
    meta: {
      type: "list",
    },
    component: Feedback,
  },
  //快速体验
  {
    path: "/trial",
    meta: {
      type: "test",
      trial: true,
    },
    component: () => import("@/views/BlockPage.vue"),
    children: [
      {
        path: "examlist",
        meta: {
          type: "examlist",
          trial: true,
        },
        component: () => import("@/views/trial/List.vue"),
      },

      {
        path: "reports",
        meta: {
          type: "reports",
          trial: true,
        },
        component: () => import("@/views/report/TrialList.vue"),
      },
      {
        path: "oraltest",
        meta: {
          type: "test",
          trial: true,
        },
        component: () => import("@/views/testSet/OralTest.vue"),
      },
      {
        path: "exam",
        meta: {
          type: "exam",
          trial: true,
        },
        component: () => import("@/views/trial/ExamBlock.vue"),
        children: [
          {
            path: "vspt",
            meta: {
              type: "exam",
              skill: "S0",
              trial: true,
            },
            component: () => import("@/views/trial/exam-Vocabulary.vue"),
          },
          {
            path: "grammar",
            meta: {
              type: "exam",
              trial: true,
            },
            component: () => import("@/views/trial/exam-Grammar.vue"),
          },
          {
            path: "reading",
            meta: {
              type: "exam",
              trial: true,
            },
            component: () => import("@/views/trial/exam-Reading.vue"),
          },
          {
            path: "writing",
            meta: {
              type: "exam",
              trial: true,
            },
            component: () => import("@/views/trial/exam-Writing.vue"),
          },
          {
            path: "listen",
            meta: {
              type: "exam",
              trial: true,
            },
            component: () => import("@/views/trial/exam-Listen.vue"),
          },
          {
            path: "oral",
            meta: {
              type: "exam",
              trial: true,
            },
            component: () => import("@/views/trial/exam-Oral.vue"),
          },
        ],
      },
    ],
  },
  {
    path: "/oraltest",
    meta: {
      type: "test",
    },
    component: OralTest,
  },
  {
    path: "/userinfo",
    meta: {
      type: "list",
    },
    component: UserInfo,
  },
  {
    path: "/userextend",
    meta: {
      type: "user",
    },
    component: () => import("@/views/user/UserExtend.vue"),
  },

  {
    path: "/401",
    meta: {
      type: "wrong",
    },
    component: () => import("@/views/WrongPage.vue"),
  },
  {
    path: "/403",
    meta: {
      type: "wrong",
    },
    component: () => import("@/views/WrongPage.vue"),
  },
];
const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
// 拦截器
router.beforeEach((to, from, next) => {
  for (let i = 0; i < 999; i++) {
    clearInterval(i);
    clearTimeout(i);
  }

  next();
});
router.afterEach(() => {
  let messageList = document.getElementsByClassName("el-message");
  for (let i = 0; i < messageList.length; i++) {
    messageList[i].style = "display:none";
  }
});
